import { render, staticRenderFns } from "./KzsItems.vue?vue&type=template&id=3660a193"
import script from "./KzsItems.vue?vue&type=script&lang=js"
export * from "./KzsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports